<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">UoM</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="showAddForm = true; form = {name: '', description: ''}" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewData"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeData"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="showFilterForm = true"
            icon="filter_list"
          >Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="data"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
      <!-- <vs-prompt
            @accept="filterData"
            title="Filter"
            :active.sync="showFilterForm"
        >
            <div class="con-exemple-prompt">
                <vs-input placeholder="Order Type" v-model="filter.name" class="mt-4 mb-2 w-full" />
                <vs-input placeholder="Description" v-model="filter.description" class="mt-4 mb-2 w-full" />
            </div>
      </vs-prompt>-->

      <!-- Form filter data -->
      <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="filter.name" class="mb-2 w-full" label="Name" />
          <vs-input v-model="filter.description" class="mb-2 w-full" label="Description" />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="filterData">Search</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form view data -->
      <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
        <div class="con-exemple-prompt">
          <vs-input v-model="form.name" class="mb-2 w-full" label="Name" :disabled="!editMode" />
          <vs-input
            v-model="form.description"
            class="mb-2 w-full"
            label="Description"
            :disabled="!editMode"
          />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
            <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>

      <!-- Form add data -->
      <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
        <div class="con-exemple-prompt">
          <vs-input id="test-input" v-model="form.name" class="mb-2 w-full" label="Name" />
          <vs-input v-model="form.description" class="mb-2 w-full" label="Description" />
          <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
            <vs-button color="primary" @click="addData">Save</vs-button>
          </vs-row>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      editMode: false,
      filter: {
        name: "",
        description: ""
      },
      form: {
        name: "",
        description: ""
      },

      // Show forms
      showFilterForm: false,
      showViewForm: false,
      showAddForm: false,

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    saveData() {
      this.isLoading = true;
      this.$http
        .put("master/uom/" + this.selectedId + "/update", this.form)
        .then(res => {
          this.isLoading = false;
          this.form = {
            name: "",
            description: ""
          };
          this.editMode = false;
          this.showViewForm = false;
          this.selectedId = null;
          this.fetchData();
          const message = res.data.message ? res.data.message : 'Saved successfully.'
          this.$vs.notify({
            color: "success",
            title: "Success",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          });
        })
        .catch(error => this.handleError(error))
    },
    addData() {
      this.isLoading = true;
      this.$http
        .post("master/uom/store", this.form)
        .then(() => {
          this.isLoading = false;
          this.form = {
            name: "",
            description: ""
          };
          this.showAddForm = false;
          this.$vs.notify({
            color: "success",
            title: "Data Added",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected data was successfully Added"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    removeData() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        accept: () => {
          this.isLoading = true;
          this.$http
            .delete("master/uom/" + this.selectedId + "/destroy")
            .then(res => {
              this.$vs.notify({
                color: "success",
                title: "Data deleted",
                iconPack: "feather",
                icon: "icon-check",
                text: "The selected data was successfully deleted"
              });
              this.selectedId = null;
              this.fetchData();
            })
            .catch(error => this.handleError(error))
        }
      });
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("master/uom?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.data = resp.data.data;
          this.totalPage = resp.data.last_page;
          this.currentPage = this.currentPage;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
        })
        .catch(() => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    viewData() {
      this.isLoading = true;
      this.$http
        .get("master/uom/" + this.selectedId)
        .then(res => {
          this.editMode = false
          this.form = res.data;
          this.showViewForm = true;
        })
        .catch(error => this.handleError(error))
        .then(() => (this.isLoading = false));
    },
    filterData() {
      this.currentPage = 1;
      this.showFilterForm = false;
      this.fetchData();
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/uom/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "uom-upload-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/uom/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload Data UoM Successfully"
          });
        })
        .catch(error => {
          this.isLoading = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            color: "danger",
            title: "Upload Failed",
            text: message
          });
        });
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post("master/uom/report/exportexcel", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "uom-list-export.xlsx");
        });
    },
    
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "UoM",
        field: "name",
        width: 120,
        filter: true
      },
      {
        headerName: "Description",
        field: "description",
        filter: true,
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>